/*!
 * jQuery Expander plugin
 * Author: Globalia
 * Licensed under the WTFPL license
 */


( function( $, window, document ) {

    "use strict";

    var pluginName = 'expander',
        defaults = {
            trigger: '[gr-grid-expander-trigger]',
            target: '[gr-grid-expander-target]'
        };

    function Plugin ( element, options ) {
        this.name = pluginName;
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this.init();
    }

    $.extend( Plugin.prototype, {
        init: function() {
            for( var i in defaults ){
                this.settings[i] = $(this.element).attr('gr-grid-expander-'+i)  || this.settings[i];
            }
            this.$targets =  $(this.element).find(this.settings.target);
            this.$triggers = $(this.element).find(this.settings.trigger);
            this.paddings = parseInt($(this.element).css('padding-bottom'), 10); // get padding bottom to be able to increment on expand or reset default value on collapse

            var instance = this;


            if (! $(instance.element).find('[gr-grid-expander-wrapper]').length) {
                instance.$targets.wrapInner( "<div gr-grid-expander-wrapper></div>" ); // we need an inner wrapper to be able to calculate the height before we expand
            }

            if ($(instance.element).hasClass('is-expanded')) {
                instance.expand();
            }

            instance.$triggers.on('click', function(e) {
                e.preventDefault();

                if ($(instance.element).hasClass('is-expanded')) {
                    instance.collapse();
                } else {
                    instance.collapse($(instance.element).siblings('.is-expanded')); // first collapse already expanded elements
                    instance.expand();
                }
            });
        },
        expand: function(item) {
            var instance = this;
            if (typeof item === 'undefined') {
                item = $(instance.element); // default is current instance
            }

            $(this.element).parent().addClass('is-selected');

            var wrapper = item.find('[gr-grid-expander-wrapper]'),
                contentH = wrapper.prop('scrollHeight'); // get real height of hidden content
                var scrollTop = item.offset().top - 115;

                $("html, body").stop().animate({ scrollTop: scrollTop }, 700);
                // if (!item.find(instance.settings.target).isInViewport()) {}

            item.find(instance.settings.target).css('height', contentH); // set height on hidden content
            item
                .addClass('is-expanded')
                .css('padding-bottom', instance.paddings + contentH); // add target height to padding bottom of element
        },
        collapse: function(item) {
            var instance = this;
            if (typeof item === 'undefined') {
                item = $(instance.element); // default is current instance
            }

            $(this.element).parent().removeClass('is-selected');

            item.find(instance.settings.target).css('height', 0).removeAttr('style');
            item
                .removeClass('is-expanded')
                .css('padding-bottom', instance.paddings);
        },
        callFunction: function (call, options) {
            if(typeof this[call] === 'function') {
                return this[call](options);
            }
        }
    } );

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[ pluginName ] = function(call, options ) {
        return this.each( function() {
            if ( !$.data( this, "plugin_" + pluginName ) ) {
                $.data( this, "plugin_" + pluginName, new Plugin( this, options || call ) );
            } else {
                return $.data(this, "plugin_" + pluginName).callFunction(call, options);
            }
        });
    };

    $(function () {
        $(document).find('[gr-grid-expander]').expander();
    });

    // Collapse expanded areas on resize for desktops / on orientation change for mobiles

    var isTouch = ('ontouchstart' in window) || (window.navigator.msMaxTouchPoints),
        collapseEvent = '';

    if (isTouch) {
        collapseEvent = 'orientationchange';
    } else {
        collapseEvent = 'resize';
    }

    $(window).on(collapseEvent, function () {
        $('[gr-grid-expander]').each(function() {
            $(this).expander('collapse', $(this));
        })
    });

    function getScrollTop(){
        if (typeof pageYOffset!= 'undefined'){
            //most browsers except IE before #9
            return pageYOffset;
        }
        else {
            var B = document.body; //IE 'quirks'
            var D = document.documentElement; //IE with doctype
            D = (D.clientHeight) ? D : B;
            return D.scrollTop;
        }
    }

    $.fn.isInViewport = function() {
        var offset = 30;
        var elementTop = $(this).offset().top + offset;
        var elementBottom = elementTop + $(this).outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };

}(require('jquery'), window, document));
